module.exports = __webpack_public_path__ + "static/media/gaming.c407780a.svg";